import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=1c054c52&scoped=true"
import script from "./guest.vue?vue&type=script&lang=js"
export * from "./guest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c054c52",
  null
  
)

export default component.exports